import React from 'react';
import {Header,Item, Label,  Breadcrumb, Embed, Transition, Icon, Segment,Container, Loader,Image, Dropdown, Divider, Form, Dimmer, TextArea,   Button, Grid,Input, Radio, Message} from 'semantic-ui-react';
import { Link } from "react-router-dom";
import Content from '../NetflixSlider/ContentHeader';
import Slider from '../NetflixSlider'; 
import Insignias from './Insignias';
import Modulos from './Modulos';
import SlideShow from 'react-slideshow-ui';
import Crossword from '@jaredreisinger/react-crossword';
import Quiz from 'react-quiz-component';
//import Player from 'react-media-viewer';
import moment from 'moment';
import { Document, Page } from 'react-pdf';
//import ReactPlayer from 'react-player/lazy'
import ReactPlayer from 'react-player/lazy'
import $ from 'jquery';

$(document).ready(function(){

        $('#videoElementID').bind('contextmenu',function() { return false; });
    });


const Miespacio=({ id, color, idTipoContenido, referencia, urlContenido , onSeek,tituloContenido,  curso, onVisible, regresar, visible, onAcordionModulo, modulos,cursosActuales,cursosPrevios,  form, onSave,onChange, ajaxCallInProgress, datos, errors={}, strings, permisos, quiz, setQuizResult, renderCustomResultPage, showModalComents,fechaActual, handleClick, videoProgreso, onDuration,videoTerminado, fechaComentario, errorExamen, saveExamen, dataCrucigrama, dataArray })=>{
    
    /*ll
        <div className="app">
           
            {fechaActual.format('MM/DD/YYYY HH:mm:ss')
            
            
            
            
            }
<br/>

            {moment('1/10/2022 9:23:00').format("MM/DD/YYYY HH:mm:ss")}
<br/>
            {moment('1/10/2022 9:24:00').format("MM/DD/YYYY HH:mm:ss")}
            
            {fechaActual.isAfter(moment('1/10/2022 9:23:00')) && fechaActual.isBefore(moment('1/10/2022 9:25:00'))?
                <div>
                OPEN
                </div>    
            :
                <div>
                CLOSE
                </div>
            }
             <Segment basic>    
                            <button onClick={handlePlayPause}>{playing ? 'Pause' : 'Play'}</button>  
                            <button onClick={()=>handleSetPlaybackRate(1)} >1x</button>
                            <button onClick={()=>handleSetPlaybackRate(1.5)} >1.5x</button>
                            <button onClick={()=>handleSetPlaybackRate(2)} >2x</button>        
                            <input type='range' min={0} max={1} step='any' value={volume} onChange={(e)=>{handleVolumeChange(e)}} />Volumen    
                            </Segment>    
            <ReactPlayer url={urlContenido}  
            <ReactPlayer url="https://www.youtube.com/watch?v=PbtDGKp73y8"
            onProgress={(progress) => {
                                       videoProgreso(progress);
                                     }}   
                                     
                                       <ReactPlayer url={urlContenido}  
    */
    
    
    
    /*
     <Grid.Row only='computer tablet' >
                        <Grid.Column textAlign="center" >
                            <div style={{"height": "45em"}}>
                                 <Divider />
                                      <Player 
                                        width={"90%"}
                                        height={"90%"}
                                        playing={true}
                                        metadata={{
                                            title: "tituloContenido",
                                            
                                        }
                                    }
                                    theme={{
                                        bgColor: "#000000",
                                        textColor: "#ffffff",
                                        topBarHeight: "70px",
                                        bottomBarHeight: "80px",
                                        highlightColor: "#ff0000"
                                    }}
                                    url={urlContenido}
                                />
                                
                                <ReactPlayer url={urlContenido} 
                                     width='100%'
                                     height='100%'
                                     controls={true}
                                     playing={true}
                                    />
                                
                            </div>    
                         </Grid.Column>
                </Grid.Row>
                <Grid.Row  only='mobile'>
                        <Grid.Column textAlign="center" >
                            <div style={{"height": "25em"}}>
                                 <Divider />
                                      <Player 
                                        width={"90%"}
                                        height={"90%"}
                                        playing={true}
                                        metadata={{
                                            title: "tituloContenido",
                                            
                                        }
                                    }
                                    theme={{
                                        bgColor: "#000000",
                                        textColor: "#ffffff",
                                        topBarHeight: "70px",
                                        bottomBarHeight: "80px",
                                        highlightColor: "#ff0000"
                                    }}
                                    url={urlContenido}
                                />
                            </div>    
                         </Grid.Column>
                </Grid.Row>
                <ReactPlayer url={urlContenido} 
                    
                    
                    
                <Segment basic  >
        <Grid >
            <Grid.Row only='computer tablet'>
                     <Grid.Column>
                               <Content  movie={curso}/>
                     </Grid.Column>
            </Grid.Row>
            <Grid.Row only='mobile' >
               
                        <Grid.Column textAlign="center">
                            <Image src={curso.image} fluid />
                        </Grid.Column>    

            </Grid.Row>    
        </Grid>
        </Segment>   
        
                            <ReactPlayerSin url={urlContenido}
                                    onDuration={onDuration}
                                    onProgress={(progress) => {videoProgreso(progress)}}
                                    onEnded={videoTerminado}
                                    ref={referencia}
                                    onSeek={e => //console.log('onSeek', e)}
                                    width='100%'
                                    controls={true}
                                    
                                     config={{ file: { 
                                        attributes: {
                                          controlsList: 'nodownload'
                                        }
                                      }}}

                                    playing={true}
                                   
                                    />
        
         
    */
    
    let data={
  across: {
    1: {
      clue: 'one plus one',
      answer: 'TWO',
      row: 0,
      col: 0,
    },
  },
  down: {
    2: {
      clue: 'three minus two',
      answer: 'ONE',
      row: 0,
      col: 2,
    },
  },
};
    let currentSlide={
    id: 5,
        url:"/curso/",   
    image: '/images/capsula.jpeg',
    imageBg: '/images/capsula.jpeg',
    title: 'Cápsulas de Control de Calidad'
      , desc:"Mi descripcnp ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque"+
          "et euismod ligula. Morbi mattis pretium eros, ut mollis leo tempus"+
          "eget. Sed in dui ac ipsum feugiat ultricies. Phasellus vestibulum enim"+
          "quis quam congue, non fringilla orci placerat. Praesent sollicitudin"

  };
    
    
  
	return (
        <div>
            <Dimmer.Dimmable   dimmed={ajaxCallInProgress>0?true:false}>
        
      
        <Grid>
             <Grid.Row only='computer tablet'>
                <Grid.Column textAlign="center" width={16}>

                    {curso.imageCr!=null?
                        <Image src={curso.imageCr} fluid  />
                    :
                        <Image size="large"  src={curso.image} wrapped  />
                    }
                </Grid.Column>
            </Grid.Row>  
            <Grid.Row only='mobile' >
               
                <Grid.Column textAlign="center">
        
                    <Image src={curso.image} fluid />
                </Grid.Column>    

            </Grid.Row>    
        
        
        </Grid>
       
        
            <Segment basic>
        
                
                {visible?
         <Modulos 
                    allowAccess={curso.allowAccess}    
                    titulo={curso.title}
                    modulos={curso.modulos} 
                    onVisible={onVisible}
                    onAcordionModulo={onAcordionModulo}
                    showModalComents={showModalComents}
                    handleClick={handleClick}
                    fechaActual={fechaActual}
                    fechaComentario={fechaComentario}/>
        
                 
        :""}
                 

             <Dimmer active={ajaxCallInProgress>0?true:false} inverted>
                    <Loader size='big'  content={strings?strings["Procesando"]:""}/>
              </Dimmer>

        
        {idTipoContenido==26 &&visible==false ?
        <div>
                <Header as='h3'>{tituloContenido}</Header>
                <Button onClick={regresar} color='instagram' fluid size='large'>
                    Regresar 
                </Button> 
        
                <Embed
                    icon='right circle arrow'
                    placeholder='/images/image-16by9.png'
                    url={urlContenido}
                    active={true}
                />
            <Grid>        
            <Grid.Row only='tablet'>
                     <Grid.Column>
                        <Segment basic>
                            Si no puedes ver el pdf da clic en Link
                            <Icon size="large" color="green" link onClick={()=>handleClick(urlContenido)} name="linkify" />
                        </Segment>
                    </Grid.Column>
                </Grid.Row>    
            </Grid>
        
        
        
        </div>
        :""}
        
        
        {idTipoContenido==27 &&visible==false ?
            <div>
            
            <Grid >
                    <Grid.Row >
                        <Grid.Column>   
                            <Header as='h3'>{tituloContenido}</Header>
                        </Grid.Column>
                </Grid.Row> 
                <Grid.Row>
                        <Grid.Column>
                            <Button onClick={regresar} color='instagram' fluid size='large'>
                                Regresar
                            </Button>
                </Grid.Column>
                </Grid.Row>
                <Grid.Row >
                        <Grid.Column textAlign="center" >
                           
                            <div style={{"height": "45em"}} id="videoElementID">
                                <ReactPlayer url={urlContenido}
                                    onDuration={onDuration}
                                    onProgress={(progress) => {videoProgreso(progress)}}
                                    onEnded={videoTerminado}
                                    ref={referencia}
                                    onSeek={e => console.log('onSeek', e)}
                                    width='100%'
                                    controls={true}
                                    
                                     config={{ file: { 
                                        attributes: {
                                          controlsList: 'nodownload'
                                        }
                                      }}}

                                    playing={true}
                                   
                                    />
                                
                            </div>    
                            
                         </Grid.Column>
                </Grid.Row>
                                    
                                    
                </Grid>

            </div>
        :""}
        
        
        {idTipoContenido==29 &&visible==false ?
            <div>
            
            <Grid >
                    <Grid.Row >
                        <Grid.Column>   
                            <Header as='h3'>{tituloContenido}</Header>
                        </Grid.Column>
                </Grid.Row> 
                <Grid.Row>
                        <Grid.Column>
                            <Button onClick={regresar} color='instagram' fluid size='large'>
                                Regresar
                            </Button>
                </Grid.Column>
                </Grid.Row>
                <Grid.Row >
                        <Grid.Column textAlign="center" >
                           
                            <div  >
                            
                                <Image src={urlContenido} size="huge"  centered />
                                <a href={urlContenido} download="proposed_file_name">Clic para descargar la imagen</a>
                                
                            </div>    
                            
                         </Grid.Column>
                </Grid.Row>
                                    
                                    
                </Grid>

            </div>
        :""}
        
        
        
        {idTipoContenido==1 &&visible==false ?
        <div>
            <Header as='h3'>Modulo 1: Interpreta claramente los resultados de pruebas inmunohematológicas</Header>
               <Button onClick={regresar} color='instagram' fluid size='large'>
            Regresar
          </Button>
        
        <Embed
            id='O6Xo21L0ybE'
            
            source='youtube'
          />
        
        </div>
        :""}


        {idTipoContenido==32 &&visible==false ?
         <div>
            
            <Grid >
                    <Grid.Row >
                        <Grid.Column>   
                            <Header as='h3'>{tituloContenido}</Header>
                        </Grid.Column>
                </Grid.Row> 
                <Grid.Row>
                        <Grid.Column>
                            <Button onClick={regresar} color='instagram' fluid size='large'>
                                Regresar
                            </Button>
                </Grid.Column>
                </Grid.Row>
                <Grid.Row >
                        <Grid.Column textAlign="center" >
                           <Crossword data={dataCrucigrama} />
                         </Grid.Column>
                </Grid.Row>
                                    
                                    
                </Grid>

            </div>
        :""}


        
        {idTipoContenido==3 &&visible==false ?
        <div>
            <Header as='h3'>Modulo 1: Toma decisiones asertivas para la resolución de casos complejos</Header>
               <Button onClick={regresar} color='instagram' fluid size='large'>
            Regresar
          </Button>
        
        <SlideShow
          style={{width: '85%', height:'85%'}}
          images={[
            '/images/ppt1.png',
            '/images/ppt2.png',
            '/images/ppt3.png',
        '/images/ppt4.png',
        '/images/ppt5.png',
          ]}
          withTimestamp={true}
          pageWillUpdate={(index, image) => {
            //console.log(`Page Update! index: ${index}, image: ${image}`);
          }}
        />
        
        </div>
        :""}
        
        
        {idTipoContenido==4 &&visible==false ?
        <div>
            <Header as='h3'>Modulo 1: Interpreta claramente los resultados de pruebas inmunohematológicas</Header>
               <Button onClick={regresar} color='instagram' fluid size='large'>
            Regresar
          </Button>
        <Segment style={{width: '80%', height:'80%'}}>
        <Crossword data={data} />
        </Segment>
        </div>
        :""}
        
        {idTipoContenido==28 &&visible==false ?
            
            <div>
                <Button onClick={regresar} color='instagram' fluid size='large'>Regresar</Button>

            {errorExamen==true?
                <Segment>
               <Message color='red'
                      icon='info circle'
                header='Aviso'
                content='Tuvimos un problema al guardar el resultado de su examen favor de dar click en el siguiente boton a fin de volver a enviar su resultado.'
                 />
                <Button onClick={saveExamen} color='orange' fluid size='large'>Guardar resultado</Button>
                </Segment>
            :
               ""
            }

            {errorExamen==false?
                <Segment>
               <Message color='green'
                      icon='info circle'
                header='Aviso'
                content='Tu resultado fue registrado correctamente.'
                 />
                </Segment>
            :
               ""
            }

        
            {quiz.id>0?
                <Segment style={{width: '100%', height:'80%'}}>
                    <Quiz quiz={quiz} showInstantFeedback={true} onComplete={setQuizResult} showDefaultResult={false} customResultPage={renderCustomResultPage} shuffle={true}/>
                 </Segment>
            :
                ""
            }


            {quiz.id==0 && quiz.numberOfQuestions!=null?

                  <Segment  style={{width: '100%', height:'80%'}}>
                        <Header as='h3'>{quiz.quizTitle}</Header>

                        Total de preguntas:{quiz.numberOfQuestions}<br/>
                        Correctas:{quiz.numberOfCorrectAnswers}<br/>
                        Incorrectas:{quiz.numberOfIncorrectAnswers}<br/>
                        Total de puntos posibles:{quiz.totalPoints}<br/>
                        Total obtenido:{quiz.correctPoints}<br/>



                    </Segment>    
    
                :

                    ""

            }
        
        </div>
        :""}
        
        {idTipoContenido==6 &&visible==false ?
        <div>
            <Header as='h3'>Examen2</Header>
               <Button onClick={regresar} color='instagram' fluid size='large'>
            Regresar
          </Button>
        <Segment style={{width: '100%', height:'80%'}}>
        <Quiz quiz={quiz} />
        </Segment>
        </div>
        :""}
        
        
        {idTipoContenido==7 &&visible==false ?
        <div>
            <Header as='h3'>Reunion Virtual</Header>
               <Button onClick={regresar} color='instagram' fluid size='large'>
            Regresar
          </Button>
        <Segment style={{width: '80%', height:'80%'}}>
            
            <Item.Group divided>
            <Item>
              <Item.Image src='/images/virtual.jpeg' />

              <Item.Content>
                <Item.Header as='a'>Quality Academics le está invitando a una reunión de Zoom programada.</Item.Header>
                <Item.Meta>
                  <span className='cinema'>Tema: Cápsulas de Control de Calidad</span>
                </Item.Meta>
<Item.Description>Fecha: 12-Ene-2022 8:30 a.m.</Item.Description>
                
                <Item.Description>ID de reunión: 422 496 5749</Item.Description>
                <Item.Description>Código de acceso: 439084</Item.Description>
                

<Item.Extra>
                  <Label link color="blue">Unirse a la reunión</Label>
                   </Item.Extra>
              </Item.Content>
            </Item>
        </Item.Group>


        


 
        </Segment>
        </div>
        :""}
         
        
        
            </Segment>
            </Dimmer.Dimmable>
     

        </div>
	);
};



export default Miespacio;